module.exports = require('./_shared')('native-function-to-string', Function.toString);



//////////////////
// WEBPACK FOOTER
// ./~/gatsby/~/core-js/modules/_function-to-string.js
// module id = 634
// module chunks = 168707334958949